import React from 'react'
import BreadCrumb from '../components/BreadCrumb';
import Meta from '../components/Meta';
import Blogcard from '../components/Blogcard';
import Container from '../components/Container';

const Blog = () => {
  return (
    <>
        <Meta title={'Blog'} />
        <BreadCrumb title='Blog'/>
        <Container class1='blog-wrapper home-wrapper-2 py-5'>
                <div className='row'>
                    <div className='col-3'>
                        <div className='filter-card mb-3'>
                        <h3 className='filter-title'>Find By Categories</h3>
                        <div>
                            <ul className='ps-0'>
                                <li>Watch</li>
                                <li>TV</li>
                                <li>Camera</li>
                                <li>Laptop</li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    <div className='col-9'>
                        <div className='row'>
                            <Blogcard />
                            <Blogcard />
                            <Blogcard />
                            <Blogcard />
                        </div>
                    </div>
                </div>
        </Container>
    </>
  )
}

export default Blog